
$(function(){
    var $btn = $('.category-btn [data-filter]'),
    $list = $('.category-list [data-category]');
     
    $btn.on('click', function() {
      var $btnCat = $(this).attr('data-filter');
      
      $list.removeClass('is-animate');
      
      if ($btnCat == 'all') {
        $list.show().addClass('is-animate');
        $btn.parent('li').removeClass('current');
         $('.all').parent('li').addClass('current');
      } else {
         $list.hide().removeClass('is-animate').filter('[data-category~="' + $btnCat + '"]').show().addClass('is-animate');
         $btn.parent('li').removeClass('current');
         $(this).parent('li').addClass('current');
      }
      return false;
    });
  });





